// extracted by mini-css-extract-plugin
export var container = "_96-1";
export var cornerButtonContainer = "_96-5";
export var disabled = "_96-2";
export var fileContainer = "_96-4";
export var hiddenInput = "_96-3";
export var widthContainer = "_96-0";